/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Container,
} from '@material-ui/core';
import useTranslation from '../../../hooks/useTranslation';
import styles from './styles';

const SearchBanner = (props) => {
  const { classes } = props;
  const { t } = useTranslation();
  return (
    <div>
      <Container maxWidth="lg" className={classes.container}>
        <div className={classes.searchBlock}>
          <Typography component="i" className={classes.searchGuide}>
            {t('notSureWhereToStart')}
            <span className={classes.searchNewLabel}>
              {' '}
              {t('searchGuideNew')}
              {' '}
            </span>
            <a href="/decision-tree" className={classes.searchGuideLink}>
              {t('searchGuidanceTool')}
            </a>
            !
          </Typography>
        </div>
      </Container>
    </div>
  );
};

SearchBanner.propTypes = {
  classes: PropTypes.object.isRequired,
};

const enhance = compose(
  withStyles(styles),
  withRouter,
);

export default enhance(SearchBanner);
